const STATUS_TYPES = {
  success: 1,
  warning: 2,
  error: 3,
}

export {
  STATUS_TYPES,
}
